import './styles.css';

export default ({
  children,
  responsive,
  reverse,
  style,
  ...rest
}) => {
  return (
    <div className={`${responsive ? 'col-responsive' : ''} ${reverse ? 'col-reverse-common' : 'col-common'}`} style={{...style}} {...rest}>{children}</div>
  );
};
